var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "luggage-selector", class: { disabled: !_vm.storeId } },
    [
      _c("div", { staticClass: "luggage-header" }, [
        _c("div", [
          _c("div", { staticClass: "field-label" }, [
            _vm._v(_vm._s(_vm.$t("luggage") || "Luggage Items"))
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "sub-label" }, [
            _vm._v("Manage your tracking inventory")
          ])
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn-add",
            attrs: { type: "button", disabled: !_vm.storeId },
            on: { click: _vm.addItem }
          },
          [_vm._v("+ " + _vm._s(_vm.$t("addItem").replace("+ ", "")))]
        )
      ]),
      _vm._v(" "),
      !_vm.storeId
        ? _c("p", { staticClass: "hint" }, [
            _vm._v(_vm._s(_vm.$t("selectStoreFirst")))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.storeId && !_vm.sizes.length
        ? _c("p", { staticClass: "hint" }, [
            _vm._v(_vm._s(_vm.$t("noPackages")))
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "TransitionGroup",
        { staticClass: "item-list", attrs: { name: "item-fade", tag: "div" } },
        _vm._l(_vm.items, function(item, idx) {
          return _c("div", { key: item._key, staticClass: "luggage-item" }, [
            _c(
              "button",
              {
                staticClass: "btn-remove",
                attrs: { type: "button", "aria-label": "Remove item" },
                on: {
                  click: function($event) {
                    return _vm.removeItem(idx)
                  }
                }
              },
              [_vm._v("×")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "group-label" }, [
              _vm._v("ITEM CATEGORY")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "size-wrap" }, [
              _c(
                "label",
                { staticClass: "sr-only", attrs: { for: "size-" + idx } },
                [_vm._v("Size")]
              ),
              _vm._v(" "),
              _c(
                "select",
                {
                  staticClass: "field-input size-select",
                  attrs: { id: "size-" + idx },
                  domProps: { value: item.size },
                  on: {
                    change: function($event) {
                      return _vm.updateSize(idx, $event.target.value)
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "", disabled: "" } }, [
                    _vm._v(_vm._s(_vm.$t("luggageSizePlaceholder")))
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.sizes, function(s) {
                    return _c(
                      "option",
                      { key: s.value, domProps: { value: s.value } },
                      [_vm._v(_vm._s(s.label))]
                    )
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "meta-row" }, [
              _c("div", { staticClass: "qty-box" }, [
                _c("div", { staticClass: "group-label" }, [_vm._v("QUANTITY")]),
                _vm._v(" "),
                _c("div", { staticClass: "qty-controls" }, [
                  _c(
                    "button",
                    {
                      staticClass: "qty-btn",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.decrementQuantity(idx)
                        }
                      }
                    },
                    [_vm._v("−")]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "qty-value" }, [
                    _vm._v(_vm._s(_vm.formatQty(item.quantity)))
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "qty-btn primary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.incrementQuantity(idx)
                        }
                      }
                    },
                    [_vm._v("+")]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "price-box" }, [
                _c("div", { staticClass: "group-label" }, [
                  _vm._v("UNIT PRICE")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "item-fee" }, [
                  _vm._v("$" + _vm._s(_vm.feeForSize(item.size)))
                ])
              ])
            ])
          ])
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ff1eac96", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff1eac96","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LuggageSelector.vue
// module id = 410
// module chunks = 0